import styles from './EditButton.module.css';

function EditButton({ onClick, disabled }) {
  return (
    <button className={styles.editButton} onClick={onClick} disabled={disabled}>
      Edit
    </button>
  );
}

export default EditButton;